import styled from 'styled-components';
import WifiIconSvg from '../../assets/bus/amenities/wifi.svg';

const WifiIcon = styled(WifiIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  fill: ${props => props.fill || props.theme.colors.grey.grey50};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default WifiIcon;
